<template>
	<div class="work">
		<Company name="Render" post="Senior Frontend Developer" :from="new Date(2022, 4)" :to="new Date(2025, 8)">
			<li class="custom-list-item">Continuously develop dynamic and responsive user interfaces using Vue.js, React, and JavaScript.</li>
			<li class="custom-list-item">Consistently use Element UI to create visually appealing and user-friendly interfaces.</li>
			<li class="custom-list-item">
				Implemented and maintain new features on SaaS software using advanced Vue.js and JavaScript skills, resulting in a highly intuitive
				and user-friendly interface that consistently receives praise from client companies for enhancing user engagement and satisfaction.
			</li>
			<li class="custom-list-item">
				Collaborated with Python (Django) backend services, handling API integration, troubleshooting, and refining business logic as needed.
			</li>
			<li class="custom-list-item">
				Maintained and optimized existing GitHub Actions CI/CD pipelines and Docker-based environments, resolving deployment issues and
				ensuring smooth operations.
			</li>
			<li class="custom-list-item">
				Assisted with debugging and handling API integrations and data flow between frontend and backend services.
			</li>
			<li class="custom-list-item">
				Conduct Cypress E2E and Component testing to ensure the reliability and accuracy of application functionalities.
			</li>
			<li class="custom-list-item">Identify and resolve errors and bugs to enhance and stabilize the user experience.</li>
			<li class="custom-list-item">
				Collaborate with cross-functional teams to deliver high-quality products, including documenting design specifications and features.
			</li>
			<li class="custom-list-item">Participate in code and pull request reviews to ensure code quality and adherence to best practices.</li>
			<li class="custom-list-item">
				Work within an Agile methodology, managing tasks and tracking progress using ClickUp, and contributing to sprint planning and
				execution.
			</li>

			<div class="expirience-job__projects">
				<a href="https://render.dk" target="_blank"
					><span class="el-link__inner"
						><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" style="width: 1em; margin-right: 0.25em">
							<path
								fill="currentColor"
								d="M715.648 625.152 670.4 579.904l90.496-90.56c75.008-74.944 85.12-186.368 22.656-248.896-62.528-62.464-173.952-52.352-248.96 22.656L444.16 353.6l-45.248-45.248 90.496-90.496c100.032-99.968 251.968-110.08 339.456-22.656 87.488 87.488 77.312 239.424-22.656 339.456l-90.496 90.496zm-90.496 90.496-90.496 90.496C434.624 906.112 282.688 916.224 195.2 828.8c-87.488-87.488-77.312-239.424 22.656-339.456l90.496-90.496 45.248 45.248-90.496 90.56c-75.008 74.944-85.12 186.368-22.656 248.896 62.528 62.464 173.952 52.352 248.96-22.656l90.496-90.496 45.248 45.248zm0-362.048 45.248 45.248L398.848 670.4 353.6 625.152 625.152 353.6z"
							></path></svg
						>Render</span
					></a
				><a href="https://chesschamps.io/" target="_blank"
					><span class="el-link__inner"
						><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" style="width: 1em; margin-right: 0.25em">
							<path
								fill="currentColor"
								d="M715.648 625.152 670.4 579.904l90.496-90.56c75.008-74.944 85.12-186.368 22.656-248.896-62.528-62.464-173.952-52.352-248.96 22.656L444.16 353.6l-45.248-45.248 90.496-90.496c100.032-99.968 251.968-110.08 339.456-22.656 87.488 87.488 77.312 239.424-22.656 339.456l-90.496 90.496zm-90.496 90.496-90.496 90.496C434.624 906.112 282.688 916.224 195.2 828.8c-87.488-87.488-77.312-239.424 22.656-339.456l90.496-90.496 45.248 45.248-90.496 90.56c-75.008 74.944-85.12 186.368-22.656 248.896 62.528 62.464 173.952 52.352 248.96-22.656l90.496-90.496 45.248 45.248zm0-362.048 45.248 45.248L398.848 670.4 353.6 625.152 625.152 353.6z"
							></path></svg
						>Chess Champs</span
					></a
				>
			</div>
			<div class="expirience-job__list">
				<div class="expirience-job__item">React</div>
				<div class="expirience-job__item">VueJS 2/3</div>
				<div class="expirience-job__item">JavaScript</div>
				<div class="expirience-job__item">Python</div>
				<div class="expirience-job__item">Django</div>
				<div class="expirience-job__item">SCSS</div>
				<div class="expirience-job__item">HTML</div>
				<div class="expirience-job__item">Gulp</div>
				<div class="expirience-job__item">Git</div>
				<div class="expirience-job__item">Cypress</div>
			</div>
		</Company>
		<Company name="Cellari" post="Frontend Developer" :from="new Date(2021, 12)" :to="new Date(2022, 4)">
			<li class="custom-list-item">
				Developed new features and initiatives using JavaScript (Vanilla.js), CSS, and HTML at Cellari (Software).
			</li>
			<li class="custom-list-item">
				Managed time-sensitive updates, including content changes and database upgrades to improve user interface features.
			</li>
			<li class="custom-list-item">Collaborated with cross-functional teams to enhance the existing platform and drive user engagement.</li>

			<div class="expirience-job__projects">
				<a href="https://cellari.io/" target="_blank" rel="noopener noreferrer"
					><span>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" style="width: 1em; margin-right: 0.25em">
							<path
								fill="currentColor"
								d="M715.648 625.152 670.4 579.904l90.496-90.56c75.008-74.944 85.12-186.368 22.656-248.896-62.528-62.464-173.952-52.352-248.96 22.656L444.16 353.6l-45.248-45.248 90.496-90.496c100.032-99.968 251.968-110.08 339.456-22.656 87.488 87.488 77.312 239.424-22.656 339.456l-90.496 90.496zm-90.496 90.496-90.496 90.496C434.624 906.112 282.688 916.224 195.2 828.8c-87.488-87.488-77.312-239.424 22.656-339.456l90.496-90.496 45.248 45.248-90.496 90.56c-75.008 74.944-85.12 186.368-22.656 248.896 62.528 62.464 173.952 52.352 248.96-22.656l90.496-90.496 45.248 45.248zm0-362.048 45.248 45.248L398.848 670.4 353.6 625.152 625.152 353.6z"
							></path></svg
						>Cellari
					</span></a
				>
			</div>
			<div class="expirience-job__list">
				<div class="expirience-job__item">JavaScript</div>
				<div class="expirience-job__item">HTML/CSS</div>
				<div class="expirience-job__item">GitLab</div>
			</div>
		</Company>
		<Company name="Dianox" post="Fullstack Developer" :from="new Date(2021, 2)" :to="new Date(2022, 1)">
			<li class="custom-list-item">
				Built and managed the full-stack web app from scratch by using technologies Next.js, TypeScript, AWS and MongoDB.
			</li>
			<li class="custom-list-item">Worked with a UI/UX designer and the CTO to plan, write, and debug the web application.</li>
			<li class="custom-list-item">
				Integrated the app with REST APIs for Google Maps, social media logins, payment processors, and other services.
			</li>
			<li class="custom-list-item">Managed time-sensitive updates, including content changes and database upgrades.</li>

			<div class="expirience-job__projects">
				<a href="https://www.dianox.com/" target="_blank" rel="noopener noreferrer"
					><span>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" style="width: 1em; margin-right: 0.25em">
							<path
								fill="currentColor"
								d="M715.648 625.152 670.4 579.904l90.496-90.56c75.008-74.944 85.12-186.368 22.656-248.896-62.528-62.464-173.952-52.352-248.96 22.656L444.16 353.6l-45.248-45.248 90.496-90.496c100.032-99.968 251.968-110.08 339.456-22.656 87.488 87.488 77.312 239.424-22.656 339.456l-90.496 90.496zm-90.496 90.496-90.496 90.496C434.624 906.112 282.688 916.224 195.2 828.8c-87.488-87.488-77.312-239.424 22.656-339.456l90.496-90.496 45.248 45.248-90.496 90.56c-75.008 74.944-85.12 186.368-22.656 248.896 62.528 62.464 173.952 52.352 248.96-22.656l90.496-90.496 45.248 45.248zm0-362.048 45.248 45.248L398.848 670.4 353.6 625.152 625.152 353.6z"
							></path></svg
						>Dianox
					</span></a
				>
			</div>
			<div class="expirience-job__list">
				<div class="expirience-job__item">Next.js</div>
				<div class="expirience-job__item">SCSS</div>
				<div class="expirience-job__item">TypeScript</div>
				<div class="expirience-job__item">AWS</div>
				<div class="expirience-job__item">Git</div>
				<div class="expirience-job__item">MongoDB</div>
			</div>
		</Company>
		<Company name="The Considerate Consumer" post="Frontend Developer" contract :from="new Date(2020, 2)" :to="new Date(2021, 2)">
			<li class="custom-list-item">
				Assumed critical roles in front-end development with the MERN stack and JavaScript, spearheading the decision to use MERN over
				Squarespace.
			</li>
			<li class="custom-list-item">Leveraged frameworks like React.js to create responsive and dynamic web applications.</li>
			<li class="custom-list-item">
				Collaborated with cross-functional teams to design, develop, and implement user-friendly interfaces, ensuring technical feasibility
				and optimizing applications for maximum speed and scalability.
			</li>
			<li class="custom-list-item">Conducted code reviews and maintained high standards of code quality and consistency.</li>
			<div class="expirience-job__projects">
				<a href="https://www.considerate-consumer.com/" target="_blank" rel="noopener noreferrer"
					><span>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" style="width: 1em; margin-right: 0.25em">
							<path
								fill="currentColor"
								d="M715.648 625.152 670.4 579.904l90.496-90.56c75.008-74.944 85.12-186.368 22.656-248.896-62.528-62.464-173.952-52.352-248.96 22.656L444.16 353.6l-45.248-45.248 90.496-90.496c100.032-99.968 251.968-110.08 339.456-22.656 87.488 87.488 77.312 239.424-22.656 339.456l-90.496 90.496zm-90.496 90.496-90.496 90.496C434.624 906.112 282.688 916.224 195.2 828.8c-87.488-87.488-77.312-239.424 22.656-339.456l90.496-90.496 45.248 45.248-90.496 90.56c-75.008 74.944-85.12 186.368-22.656 248.896 62.528 62.464 173.952 52.352 248.96-22.656l90.496-90.496 45.248 45.248zm0-362.048 45.248 45.248L398.848 670.4 353.6 625.152 625.152 353.6z"
							></path></svg
						>The Considerate Consumer
					</span></a
				>
			</div>
			<div class="expirience-job__list">
				<div class="expirience-job__item">React</div>
				<div class="expirience-job__item">Node.js</div>
				<div class="expirience-job__item">JavaScript</div>
				<div class="expirience-job__item">Express</div>
				<div class="expirience-job__item">Git</div>
				<div class="expirience-job__item">MongoDB</div>
			</div>
		</Company>
		<Company name="Freelance (Self employed) " post="Frontend Developer" contract :from="new Date(2019, 2)" :to="new Date(2021, 2)">
			<li class="custom-list-item">
				Collaborated with clients to design and develop responsive web applications using React.js, Next.js, and TypeScript.
			</li>
			<li class="custom-list-item">
				Delivered custom UI/UX solutions tailored to client requirements, ensuring seamless user experiences across devices.
			</li>
			<li class="custom-list-item">
				Improved website performance by optimizing code, reducing load times, and enhancing accessibility standards.
			</li>
			<li class="custom-list-item">Worked with modern tools and libraries, including Redux, RTK and Tailwind CSS.</li>
			<li class="custom-list-item">Provided technical guidance and support to clients post-launch.</li>
			<div class="expirience-job__projects"></div>
			<div class="expirience-job__list">
				<div class="expirience-job__item">React</div>
				<div class="expirience-job__item">Node.js</div>
				<div class="expirience-job__item">JavaScript</div>
				<div class="expirience-job__item">Express</div>
				<div class="expirience-job__item">Git</div>
				<div class="expirience-job__item">MongoDB</div>
				<div class="expirience-job__item">Tailwind CSS</div>
				<div class="expirience-job__item">Redux</div>
				<div class="expirience-job__item">WordPress</div>
			</div>
		</Company>
		<Company name="H-Tech Supports" post="IT-Support Specialist / Field Engineer" :from="new Date(2017, 3)" :to="new Date(2019, 3)">
			<li class="custom-list-item">
				Provided a wide range of services from Web Development (Frontend and CMS) to IT Support like Hardware Troubleshooting, Asset
				Management (CMDB), Imaging Windows/Mac Software Installation, deployment, Migration and Troubleshooting.
			</li>
			<li class="custom-list-item">
				Hardware troubleshooting, Rack and Stack of router & switches, Networking, Data Migration, SCCM Management Remote Access using a
				Console cable and LAN & WAN support. Level 1 & 2.
			</li>
		</Company>
		<Company name="Metro Services" post="Functional Technician/IT support" :from="new Date(2013, 8)" :to="new Date(2018, 3)">
			<li class="custom-list-item">
				Performed equipment installation and upgrades for existing and new hardware/software at Level 1. Function check of various equipment
				such as passenger announcement (PA) and passenger information system (PIS) communications in the Copenhagen metro trains.
			</li>
		</Company>
		<Company name="Ellebæk Contact Network" post="Frontend Developer" volunteering :from="new Date(2022, 1)">
			<li class="custom-list-item">
				I'm currently volunteering as a front-end developer for Ellebæk Contact Network, maintaining and optimizing their website, resulting
				in a 40% increase in site traffic.
			</li>
			<div data-v-5230a472="" class="expirience-job__projects">
				<a href="https://www.ellebaek-contact.com/" target="_blank" rel="noopener noreferrer"
					><span>
						<svg data-v-5230a472="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" style="width: 1em; margin-right: 0.25em">
							<path
								fill="currentColor"
								d="M715.648 625.152 670.4 579.904l90.496-90.56c75.008-74.944 85.12-186.368 22.656-248.896-62.528-62.464-173.952-52.352-248.96 22.656L444.16 353.6l-45.248-45.248 90.496-90.496c100.032-99.968 251.968-110.08 339.456-22.656 87.488 87.488 77.312 239.424-22.656 339.456l-90.496 90.496zm-90.496 90.496-90.496 90.496C434.624 906.112 282.688 916.224 195.2 828.8c-87.488-87.488-77.312-239.424 22.656-339.456l90.496-90.496 45.248 45.248-90.496 90.56c-75.008 74.944-85.12 186.368-22.656 248.896 62.528 62.464 173.952 52.352 248.96-22.656l90.496-90.496 45.248 45.248zm0-362.048 45.248 45.248L398.848 670.4 353.6 625.152 625.152 353.6z"
							></path></svg
						>Ellebæk Contact Network
					</span></a
				>
			</div>
		</Company>
		<Company name="Hack Your Future" post="Mentor" volunteering :from="new Date(2021, 9)">
			<li class="custom-list-item">Serve as a mentor at HackYourFuture school in Denmark, providing guidance and support to students.</li>
			<li class="custom-list-item">Review and provide feedback on student homework and code projects, ensuring they meet quality standards.</li>
			<li class="custom-list-item">
				Offer mentorship and advice to help students overcome challenges and grow their skills in software development.
			</li>
			<div data-v-5230a472="" class="expirience-job__projects">
				<a href="https://www.hackyourfuture.dk/" target="_blank" rel="noopener noreferrer"
					><span>
						<svg data-v-5230a472="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" style="width: 1em; margin-right: 0.25em">
							<path
								fill="currentColor"
								d="M715.648 625.152 670.4 579.904l90.496-90.56c75.008-74.944 85.12-186.368 22.656-248.896-62.528-62.464-173.952-52.352-248.96 22.656L444.16 353.6l-45.248-45.248 90.496-90.496c100.032-99.968 251.968-110.08 339.456-22.656 87.488 87.488 77.312 239.424-22.656 339.456l-90.496 90.496zm-90.496 90.496-90.496 90.496C434.624 906.112 282.688 916.224 195.2 828.8c-87.488-87.488-77.312-239.424 22.656-339.456l90.496-90.496 45.248 45.248-90.496 90.56c-75.008 74.944-85.12 186.368-22.656 248.896 62.528 62.464 173.952 52.352 248.96-22.656l90.496-90.496 45.248 45.248zm0-362.048 45.248 45.248L398.848 670.4 353.6 625.152 625.152 353.6z"
							></path></svg
						>HYF
					</span></a
				>
			</div>
		</Company>
	</div>
</template>

<script>
import Company from '../Company.vue'

export default {
	name: 'Work',
	components: {
		Company,
	},
}
</script>

<style scoped lang="scss">
.work {
	.custom-list-item {
		list-style-type: none; /* Remove default bullets */
		position: relative;
		padding-left: 20px; /* Add space for the arrow */
	}

	.custom-list-item::before {
		content: '→'; /* Arrow symbol or use another symbol like '➔' */
		position: absolute;
		left: 0;
		top: 0;
	}
}
</style>
